import { z } from 'zod';

/* Cube card 7446 — Audit History — by Entity & ID.
   One row per Envers revision (newest first). `changed_fields` is a JSONB
   object: for the first revision it's the full snapshot, for subsequent
   revisions it's only the fields that differ vs the prior rev, shaped as
   { columnName: { from: <value>, to: <value> } }. */
export const AuditHistoryRowSchema = z.object({
  rev: z.coerce.number(),
  changed_at: z.string().nullable(),
  changed_by: z.string().nullable(),
  portal: z.string().nullable(),
  req_path: z.string().nullable(),
  change_type: z.enum(['INSERT', 'UPDATE', 'DELETE']).nullable(),
  /* Metabase's /query/json endpoint serializes Postgres jsonb as a string —
     parsing happens in the consumer (see ChangedFieldsCell). Allow either to
     be defensive if Metabase ever switches to returning a parsed object. */
  changed_fields: z.union([z.string(), z.record(z.string(), z.unknown()), z.null()]).nullable(),
});

export const AuditHistorySchema = z.array(AuditHistoryRowSchema);

export type AuditHistoryRow = z.infer<typeof AuditHistoryRowSchema>;
export type AuditHistory = z.infer<typeof AuditHistorySchema>;
